export default __webpack_public_path__ + "static/media/arlington_falling_apart.83fc4561.jpg";